import { SxProps } from "@mui/material";

export const defaultTableSx = {
  width: "100%",
  mt: 2,
  [".MuiDataGrid-cell"]: {
    alignContent: "center",
  },
  "& .coloured-cell": {
    paddingLeft: 0,
    paddingRight: 0,
  },
  "& .MuiDataGrid-pinnedRows .MuiDataGrid-cell": {
    fontWeight: "fontWeightBold",
  },
  "& .MuiDataGrid-pinnedRows .MuiTypography-root": {
    fontWeight: "fontWeightBold",
  },
} as const satisfies SxProps;
